export default "__VITE_ASSET__79057c12__"